<template>
  <section>
    <div class="card">
      <h6 class="mx-3 mt-2">
        {{ $t("lang.onBoarding.summary_of_responses") }} <button v-if="!generating" @click="regenerate()"
          class="btn btn-sm btn-primary float-right">{{ $t("lang.label.regenerate_sequences") }}</button>
      </h6>
      <div class="card-body mt-2 scroll-class" v-if="substepsdata && !generating">
        <div v-for="item in substepsdata">
          <EditTargetSequences @save="save($event)" class="mt-4" :item="item" />
        </div>
      </div>
      <div v-if="!substepsdata">
        <h4 class="text-center">{{ $t("lang.orders.not_sequences") }}</h4>
      </div>
      <LoadingSpinnerBar v-if="generating" />
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import EditTargetSequences from "@/components/Onboarding/EditTargetSequences.vue";
import { targetsService, targetSequencesService } from "@/_services";
import LoadingSpinnerBar from "@/components/LoadingSpinnerBar.vue";


export default {
  data() {
    return {
      productName: false,
      substepsdata: [],
      generating: false
    };
  },
  props: {
    targetId: false
  },

  computed: {
    ...mapState({})
  },

  components: {
    EditTargetSequences,
    LoadingSpinnerBar
  },
  created() {

    this.generating = true
    this.productName = "[" + this.$t("lang.token.product_name") + "]";
    this.loadSequences()
  },

  methods: {
    save(item) {
      targetSequencesService.saveSequencesByTarget(item).then(result => { });
    },
    regenerate() {
      this.generating = true
      targetSequencesService.regenerateByTarget(this.targetId).then(result => {
        this.loadSequences();
      });
    },
    loadSequences() {
      targetSequencesService.getSequencesByTarget(this.targetId).then(result => {
        this.substepsdata = result;
        this.generating = false
      });
    }
  }
};
</script>
<style>
.fix-height {
  max-height: 440px;
  overflow-y: scroll;
}

.scroll-class {
  max-height: 600px;
  overflow-y: auto;
}
</style>
